import React from 'react';
import { Home } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-100 py-12 px-6" data-id="element-68">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-69">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight text-gray-900" data-id="element-70">
          <div className="w-6 h-6 bg-brand-600 rounded flex items-center justify-center text-white" data-id="element-71">
            <Home size={14} strokeWidth={2.5} data-id="element-72" />
          </div>
          MINGA
        </div>

        <div className="flex items-center gap-6 text-sm text-gray-500 font-medium" data-id="element-73">
          <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-74">
            Términos
          </a>
          <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-75">
            Privacidad
          </a>
          <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-76">
            Contacto
          </a>
        </div>

        <div className="text-sm text-gray-400" data-id="element-77">
          © {new Date().getFullYear()} Propius. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}